import { ItemsResults } from './ItemsResults';
import { UrlsResults } from './UrlsResults';
import { VisitsResults } from './VisitsResults';
import { NagToPay } from '../level';
import { isRunning } from './shared';

export const Results = ({ job, ...props }) => {
  if (!job) {
    return;
  }

  const hasResults = job?.results && (job.results.items || job.results.hits);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      {!hasResults && <div>No results {isRunning(job?.state) ? 'yet...' : ''}</div>}
      {job.results?.items && <ItemsResults job={job} {...props} />}
      {job.results?.items?.length >= 10 && <NagToPay />}
      {job.results?.hits && <UrlsResults job={job} {...props} />}
      <VisitsResults job={job} />
    </div>
  );
};
